/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DoublonsGridDto } from './DoublonsGridDto';
import {
    DoublonsGridDtoFromJSON,
    DoublonsGridDtoFromJSONTyped,
    DoublonsGridDtoToJSON,
} from './DoublonsGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface DoublonsGridDtoPaginatedResults
 */
export interface DoublonsGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof DoublonsGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<DoublonsGridDto>}
     * @memberof DoublonsGridDtoPaginatedResults
     */
    results?: Array<DoublonsGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof DoublonsGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the DoublonsGridDtoPaginatedResults interface.
 */
export function instanceOfDoublonsGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DoublonsGridDtoPaginatedResultsFromJSON(json: any): DoublonsGridDtoPaginatedResults {
    return DoublonsGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function DoublonsGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DoublonsGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(DoublonsGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function DoublonsGridDtoPaginatedResultsToJSON(value?: DoublonsGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(DoublonsGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

